import curry from "./curry";
import render from "./render";

// Component c => c -> [c] -> HTML
const renderWrap = curry((c, children) => render(c, { children }));

export default renderWrap;
